<!-- 头部导航栏 -->
<template>
    <div
        class="head"
        @mouseleave="mainMouseLeave()"
    >
        <!-- 父级 -->
        <div class="headParend">
            <div class="head_all">
                <div class="corporateName">
                    <img
                        :src="$imgUrl + '/logo_name.png'"
                        alt=""
                    />
                </div>
                <div class="navigation">
                    <div class="navMain">
                        <div
                            class="navItem"
                            v-for="(item, index) in navData"
                            :key="index"
                            @mouseleave="handleMouseLeave()"
                            @mouseenter="handleMouseEnter(item)"
                            @click="navClick(item)"
                        >
                            <div :class="[
                  'navItemMain',
                  navSelect == item.routerId ? 'navSelect' : '',
                  handEnter == item.routerId ? 'navEnter' : '',
                ]">
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 对应的子级 -->
        <div
            class="childrenBox"
            v-show="childrenIs && childrenItem.children.length > 0"
            @mouseenter="childrenMouseEnter()"
            @mouseleave="handleMouseLeave()"
        >
            <div class="childrenMain">
                <div class="title">{{ childrenItem.title }}</div>
                <div class="childrenItemBox">
                    <div
                        class="childrenItem"
                        v-for="(item, index) in childrenItem.children"
                        :key="index"
                        @click="childrenClick(item)"
                    >
                        <div class="curBox">
                            <div class="src">
                                <img
                                    :src="$imgUrl + item.src"
                                    alt=""
                                />
                            </div>
                            <div
                                class="childrenTitle"
                                :style="{
                  color:
                    childSelect == item.routerId ? 'rgba(17, 17, 255, 1)' : '',
                }"
                            >
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, reactive, ref, watchEffect, inject } from "vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

const $imgUrl = inject("$imgUrl");

let corporateName = ref("");

// console.log(localStorage.getItem('webData'))
let webData = JSON.parse(localStorage.getItem("webData"));

corporateName = webData.title;

const props = defineProps({
    newsData: {
        type: Object,
        default: {},
    },
});

let navSelect = ref(""); // 父级选中
let childSelect = ref(""); // 子级选中

let navData = reactive([
    {
        routerId: "/index",
        title: "首页",
        children: [],
    },
    {
        routerId: "/about",
        title: "关于卓信",
        children: [
            {
                routerId: "/about/profile",
                title: "公司简介",
                src: "/navigation/about.png",
            },
            {
                routerId: "/about/layout",
                title: "市场布局",
                src: "/navigation/about2.png",
            },
            {
                routerId: "/about/developm",
                title: "产品研发",
                src: "/navigation/about3.png",
            },
            // {
            //     routerId: "/index/about4",
            //     title: '企业文化',
            //     src: '/navigation/about4.png',
            // },
            // {
            //     routerId: "/about/about5",
            //     title: '团队介绍',
            //     src: '/navigation/about5.png',
            // },
            // {
            //     routerId: "/about/about6",
            //     title: '品控管理',
            //     src: '/navigation/about6.png',
            // },
            {
                routerId: "/about/qualityCon",
                title: "品控管理",
                src: "/navigation/about7.png",
            },
            {
                routerId: "/about/ownership",
                title: "知识产权",
                src: "/navigation/about8.png",
            },
            {
                routerId: "/about/qualifica",
                title: "资质荣誉及社会任职",
                src: "/navigation/about9.png",
            },
            // {
            //     routerId: "/about/appoint",
            //     title: '社会任职与参建标准',
            //     src: '/navigation/about10.png',
            // },
        ],
    },
    {
        routerId: "/business",
        title: "核心业务",
        children: [
            {
                routerId: "/business/commun",
                title: "通信工程",
                src: "/navigation/business.png",
            },
            {
                routerId: "/business/DICT",
                title: "DICT",
                src: "/navigation/business2.png",
            },
            {
                routerId: "/business/Internetthing",
                title: "城市物联网",
                src: "/navigation/business3.png",
            },
            {
                routerId: "/business/opticalfib",
                title: "智慧光纤分配管理系统",
                src: "/navigation/business4.png",
            },
            {
                routerId: "/business/wireless",
                title: "无线通信产品",
                src: "/navigation/business5.png",
            },
        ],
    },
    {
        routerId: "/employ",
        title: "服务案例",
        children: [
            {
                routerId: "/employ/park",
                title: "智慧园区/社区",
                src: "/navigation/employ.png",
            },
            {
                routerId: "/employ/treat",
                title: "智慧医疗",
                src: "/navigation/employ2.png",
            },
            {
                routerId: "/employ/campus",
                title: "智慧校园",
                src: "/navigation/employ3.png",
            },
            {
                routerId: "/employ/firefig",
                title: "智慧消防",
                src: "/navigation/employ4.png",
            },
            {
                routerId: "/employ/waterAff",
                title: "智慧水务",
                src: "/navigation/employ5.png",
            },
            {
                routerId: "/employ/engineer",
                title: "市政工程",
                src: "/navigation/employ6.png",
            },
            {
                routerId: "/employ/distribu",
                title: "室内分布",
                src: "/navigation/employ7.png",
            },
            {
                routerId: "/employ/broadband",
                title: "宽带接入",
                src: "/navigation/employ8.png",
            },
            {
                routerId: "/employ/cover",
                title: "传输预覆盖",
                src: "/navigation/employ9.png",
            },
            {
                routerId: "/employ/funRod",
                title: "智慧多功能杆",
                src: "/navigation/employ10.png",
            },
            {
                routerId: "/employ/other",
                title: "其他案例",
                src: "/navigation/employ11.png",
            },
        ],
    },
    {
        routerId: "/news",
        title: "新闻资讯",
        children: [
            {
                routerId: "/news/newsDetail",
                title: "头部新闻",
                src: "/navigation/news.png",
            },
            {
                routerId: "/news/newsDetail",
                title: "近期新闻",
                src: "/navigation/news2.png",
            },
            {
                routerId: "/news/newsDetail",
                title: "往期重点新闻",
                src: "/navigation/news3.png",
            },
            {
                routerId: "/news/newsDetail",
                title: "历史新闻",
                src: "/navigation/news4.png",
            },
        ],
    },
  {
    routerId: "/contact",
    title: "联系我们",
    children: [],
  },
  {
    routerId: "供应商入驻",
    title: "供应商入驻",
    children: [],
    type:'link'
  },
]);

let childrenIs = ref(false);
let childrenItem = ref({});

let handEnter = ref("");

let logoImg = ref("/logo.png");

// 父级点击事件
let navClick = (val) => {

    if( val.type === "link" ) {
      window.open('https://plan.zhuoxintongxin.com:1007/')
    } else {
      navSelect.value = val.routerId;
      router.push(val.routerId);
    }
};

// 父级鼠标进入事件
let handleMouseEnter = (item) => {
    childrenItem.value = item;
    childrenIs.value = true;
    handEnter.value = item.routerId;
};
// 父级鼠标离开事件
let handleMouseLeave = () => {
    childrenIs.value = false;
};
// 子级进入事件
let childrenMouseEnter = () => {
    childrenIs.value = true;
};
// 子级离开事件
// let childrenMouseEnter = () =>{
//     childrenIs.value = true;
// }

// 子级点击
let childrenClick = (val) => {
    console.log(val.title);
    // 新闻跳转特殊处理
    if (val.routerId == "/news/newsDetail") {
        let routerNewsId = "";
        switch (val.title) {
            case "头部新闻":
                routerNewsId = `/news/newsDetail?id=${props.newsData.carouselList[0].id}&type=left`;
                break;
            case "近期新闻":
                routerNewsId = `/news/newsDetail?id=${props.newsData.recentList[0].id}`;
                break;
            case "往期重点新闻":
                routerNewsId = `/news/newsDetail?id=${props.newsData.keyPointList[0].id}`;
                break;
            case "历史新闻":
                routerNewsId = `/news/newsDetail?id=${props.newsData.history.hisToryList[0].id}`;
                break;
        }

        // console.log('routerNewsId', routerNewsId)
        router.push(routerNewsId);
        childrenIs.value = false;

        setTimeout(() => {
            window.location.reload();
        }, 100);

        return;
    }

    router.push(val.routerId);
    childrenIs.value = false;
};

// 整个组件的鼠标离开事件
let mainMouseLeave = () => {
    handEnter.value = [];
};

watchEffect(() => {
    // console.log('item', router.currentRoute.value.path);

    let pathArr = router.currentRoute.value.path.split("/");

    navSelect.value = `/${pathArr[1]}`;

    if (navSelect.value == "/news") {
        childSelect.value = "";
        return;
    }
    childSelect.value = `/${pathArr[1]}/${pathArr[2]}`;
});

// 钩子函数
onMounted(() => { });
</script>

<style lang="scss" scoped>
.head {
    height: 5rem;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    background-color: white;
    z-index: 999;

    .headParend {
        width: 100%;
        height: 5rem;
        // border: 1px solid red;
        display: flex;
        justify-content: center;
        align-items: center;
        .head_all {
            width: 60rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .corporateName {
                width: 28rem;
                opacity: 1;
                font-size: 1.4rem;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 5rem;
                color: rgba(29, 33, 41, 1);
                text-align: center;
                vertical-align: middle;
                display: flex;
                align-content: center;
                img {
                    width: 8rem;
                }
                // .font {
                //     margin-left: 10rem;
                // }
            }

            .navigation {
                flex: 1;
                .navMain {
                    display: flex;

                    .navItem {
                        height: 5rem;
                        width: 7rem;
                        // border: 1px solid red;
                        // line-height: 5rem;
                        text-align: center;
                        font-family: "Source Han Sans";
                        font-weight: 400;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        // &:hover {
                        //     .navItemMain {
                        //         font-weight: 700;
                        //         color: rgba(0, 0, 255, 1);
                        //         border-bottom: 2px solid rgba(0, 0, 255, 1);
                        //     }
                        // }

                        .navItemMain {
                            height: 3rem;
                            width: 5rem;
                            line-height: 3rem;
                        }

                        .navSelect {
                            color: rgba(0, 0, 255, 1);
                            border-bottom: 2px solid rgba(0, 0, 255, 1);
                        }

                        .navEnter {
                            font-weight: 700;
                            color: rgba(0, 0, 255, 1);
                            border-bottom: 2px solid rgba(0, 0, 255, 1);
                        }
                    }
                }
            }
        }

        // .logo {
        //   width: 15rem;
        //   display: flex;
        //   .logoImg {
        //     width: 2rem;
        //     height: 2rem;
        //     background-size: 100% 100%;
        //     margin: 1.5rem 10px 0 0;
        //   }

        //   .logoFont {
        //     height: 5rem;
        //     line-height: 5rem;
        //     font-size: 0.8rem;
        //   }
        // }
    }

    .childrenBox {
        width: 100%;
        // height: 5rem;
        // border: 1px solid red;
        background-color: #f4f5f7;
        // padding: 0 15rem 0rem 30.5rem;
        z-index: 999;

        // width: calc(100% - 28rem - 15rem);

        .childrenMain {
            width: 60rem;
            margin: auto;
        }

        .title {
            height: 4rem;
            line-height: 4rem;
            font-weight: 700;
            font-size: 1rem;
        }

        .childrenItemBox {
            display: flex;
            // border: 1px solid red;
            flex-wrap: wrap;

            .childrenItem {
                width: 16.6%;
                // border: 1px solid pink;
                padding: 0rem 1rem 1rem 0;

                .curBox {
                    cursor: pointer;
                }

                .src {
                    width: 100%;
                    // height: 10rem;
                    // border: 1px solid red;
                    border-radius: 0.8rem;
                    overflow: hidden;

                    img {
                        width: 100%;
                        display: block;
                        vertical-align: middle;
                    }
                }

                .childrenTitle {
                    // height: 5rem;
                    // line-height: 5rem;
                    font-size: 0.8rem;
                    font-weight: 700;
                    margin: 10px 0;
                }
            }
        }
    }
}
</style>